import { getTimeStamp } from '../../webcommon/common/helpers';
import * as constants from './constants';
import * as actions from './actions';

export const INITIAL_STATE = {
    columns: constants.columns,
    filterDefinitions: constants.filterDefinitions,
    defaultFilters: constants.defaultFilters,
    loading: false,
    initialised: false,
    lastUpdated: getTimeStamp(),
    rows: [],
    gridSorting: constants.defaultGridSorting
};

export default function reducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {
        case actions.SET_INITIALISED:
            return { ...state, initialised: action.initialised };
        case actions.SET_FILE_AVAILABILITY_LOADING:
            return { ...state, loading: action.loading };
        case actions.GET_FILE_AVAILABILITY_SUCCESS:
            return { ...state, rows: action.result, lastUpdated: getTimeStamp() };
        case actions.SET_GRID_SORTS: {
            const alreadyExists = state.gridSorting.find(sort => sort.gridId === action.gridId);
            if (!alreadyExists) {
                return {
                    ...state,
                    gridSorting: state.gridSorting.concat({ gridId: action.gridId, gridSort: action.sorting })
                };
            }
            return {
                ...state,
                gridSorting: state.gridSorting.map(
                    sort => (sort.gridId === action.gridId ? { ...sort, gridSort: action.sorting } : sort)
                )
            };
        }
        default:
            return state;
    }
}
